/**
 * Cart Reducer
 */

import {
  CART_CHECK_AND_CONTINUE,
  CART_CHECK_AND_CONTINUE_COMPLETE,
} from './constants';

export const initialState = {
  cartMessage: undefined,
  isSubmitting: undefined,
};

function cartReducer(state = initialState, action) {
  switch (action.type) {
    case CART_CHECK_AND_CONTINUE: {
      return {
        ...state,
        cartMessage: undefined,
        isSubmitting: true,
      };
    }
    case CART_CHECK_AND_CONTINUE_COMPLETE:
      return {
        ...state,
        cartMessage: action.message,
        isSubmitting: false,
      };

    default:
      return state;
  }
}

export default cartReducer;
